export const columnHeader = [
  {
	key: 'name', name: 'Name', type: 'text', system: false, filter: true
  },
  {
    key: 'url', name: 'Url', type: 'text', system: false, filter: true
  },
  {
	key: 'users', name: 'Users', type: 'text', system: true, filter: true
  },
  {
	key: 'actions', name: '', type: 'actions', system: true, filter: false
  }
];

export const useCases = [
	{
		"id": 1,
		"slug":"rank_tracking",
		"name":"Rank Tracking",
		"users": 5
	},
	{
		"id": 2,
		"slug":"sales_intelligence",
		"name":"Sales Intelligence",
		"users": 5
	},
	{
		"id": 3,
		"slug":"social_media_scrapping",
		"name":"Social Media Scrapping",
		"users": 5
	},
	{
		"id": 4,
		"slug":"web_scrapping",
		"name":"Web Scrapping",
		"users": 5
	}
];